export default class Integration {
    id: number | null;
    uuid: string | null;
    name: string;
    service: string;
    product_settings: any;
    order_settings: any;
    last_product_export_at: string | null;
    language_aliases: Array<string>;
    dropshippers_price_templates: Array<any>;
    credentials: any;

    constructor(data: any) {
        this.id = data?.id ?? null;
        this.uuid = data?.uuid ?? null;
        this.name = data?.name ?? '';
        this.service = data?.service ?? '';
        this.product_settings = data?.product_settings ?? {};
        this.order_settings = data?.order_settings ?? {};
        this.last_product_export_at = data?.last_product_export_at ?? null;
        this.language_aliases = data?.language_aliases ?? [];
        this.dropshippers_price_templates = data?.dropshippers_price_templates ?? [];
        this.credentials = data?.credentials ?? {};
    }
}